export const Edition = {
    Enterprise: "Enterprise",
    Professional: "Professional",

} as const;

export enum PlanType{
    NonHosted ="NonHosted",
    Hosted = "Hosted"
}